module.exports = __webpack_public_path__ + "images/application/sparkles-e8932ad9.svg";